const { getProperty } = require('../PropertyGetter');

const getLowAvailabilityMessage = function (viewState, selectedUpcItem) {
  try {
    let message;

    if (selectedUpcItem) {
      message = getProperty(selectedUpcItem, 'availability.availabilityMessage');
    } else {
      message = getProperty(viewState, 'detail.selectedUpcItem.availability.availabilityMessage');
    }

    if (message === 'Just a few left') {
      return message;
    }

    return '';
  } catch (err) {
    return '';
  }
};

module.exports = {
  getLowAvailabilityMessage,
};



// WEBPACK FOOTER //
// /Users/m802941/WebstormProjects/2020/campaigns/shop-the-look-pdp/node_modules/@page/digital-product-ui-mcom/src/js/util/viewState/lowAvailabilityMessage.js